<script setup lang="ts">
defineProps({ blok: Object })
</script>

<template>
    <section class="py-9 bg-chsc-raw">
        <UiContainer
            :max-width="'max-w-full'"
            class="px-9"
        >
            <p
                v-if="blok?.eyebrow"
                class="font-montserrat fs-xl text-chsc-indigo-500"
            >
                {{ blok?.eyebrow }}
            </p>
            <h1 class="-mt-2 font-londrina-solid fs-7xl font-bold uppercase text-chsc-indigo-500">
                {{ blok?.title }}
            </h1>
        </UiContainer>
    </section>
</template>